<div class="main_header">
  <h1>Agencies</h1>
</div>

<div class="step_container">
  <div class="main_container">
    <div class="deals_container">
      <div class="deals_sub_container">
        <div class="filter_title">All Agencies</div>
        <div class="deals_option align-right">
          <div class="search_bar">
            <div class="table_action_cell" *ngIf="showSearchInput">
              <mat-form-field style="width: auto" class="no-padding" appearance="outline">
                <input matInput class="placeholders" (keyup)="searchAgency($event)" placeholder="Search" #input />
                <mat-icon matSuffix class="material-icons search_icon" (click)="showSearchInput = false">search
                </mat-icon>
              </mat-form-field>
            </div>

            <div class="table_action_cell" *ngIf="!showSearchInput">
              <button mat-button class="search-btn" (click)="showSearchInput = true">
                <i class="material-icons search-btn-icon"> search </i>
              </button>
            </div>
          </div>
        </div>
        <div>
          <table style="width: 100%;" mat-table #agencyTableSort="matSort" [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="checkbox">
              <th mat-header-cell *matHeaderCellDef> </th>
              <td mat-cell *matCellDef="let row" style="min-width: 5em !important;">
                <div class="table-checkboxes">
                  <mat-checkbox (click)="addAgencies(row)">
                  </mat-checkbox>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 5em !important;">
                <span class="table_header_name"> ID</span>
              </th>
              <td mat-cell *matCellDef="let row" style="min-width: 5em !important;">
                <span class="table_value_name_non_capital"> {{ row.id }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 15em !important;">
                <span class="table_header_name"> Name</span>
              </th>
              <td mat-cell *matCellDef="let row" style="min-width: 15em !important;">
                <span class="table_value_name_non_capital"> {{ row.name }}</span>
                <!-- <a style="color: black" class="cursor_pointer" [routerLink]="['/agency/' + row.id + '/edit/']">
                <span class="table_value_name_non_capital"> {{ row.name }}</span>
              </a> -->
              </td>
            </ng-container>

            <ng-container matColumnDef="state">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 8em !important;">
                <span class="table_header_name"> State</span>
              </th>
              <td mat-cell *matCellDef="let row" [style.color]="row.color" style="min-width: 8em !important;">
                <div
                  [ngClass]="{'mat_chip_status': true, 'status_active': row.state=='active', 'status_inactive': row.state!='active'}">
                  <span class="status-label">
                    {{row.state}}
                  </span>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="4">
                No data matching the filter
              </td>
            </tr>
          </table>

          <mat-paginator #agencyPaginator [pageSizeOptions]="[10, 15, 25, 100]" (page)="handlePageEvent($event)"
            [length]="agencyCount"></mat-paginator>
        </div>
      </div>
      <div class="deals_sub_container">
        <div class="filter_title">Selected Agencies</div>
        <div class="deals_option align-right">
          <!-- <div class="search_bar">
          <div class="table_action_cell" *ngIf="showSearchInputSelected">
            <mat-form-field style="width: auto" class="no-padding" appearance="outline">
              <input matInput class="placeholders" placeholder="Search" #input />
              <mat-icon matSuffix class="material-icons search_icon" (click)="showSearchInputSelected = false">
                search
              </mat-icon>
            </mat-form-field>
          </div>

          <div class="table_action_cell" *ngIf="!showSearchInputSelected">
            <button mat-button class="search-btn" (click)="showSearchInputSelected = true">
              <i class="material-icons search-btn-icon"> search </i>
            </button>
          </div>
        </div> -->
        </div>
        <div>
          <table style="width: 100%;" #AgnSortSelected="matSort" mat-table [dataSource]="dataSourceAgnSelected" matSort>
            <ng-container matColumnDef="checkbox">
              <th mat-header-cell *matHeaderCellDef>
                <div class="table-checkboxes">
                  <mat-checkbox [checked]="selectedAgenies.length>0" (change)="removeAllAgencies()">
                  </mat-checkbox>
                </div>
              </th>
              <td mat-cell *matCellDef="let row">
                <div class="table-checkboxes">
                  <mat-checkbox [checked]="true" (click)="removeAgency(row)">
                  </mat-checkbox>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="table_header_name"> ID</span>
              </th>
              <td mat-cell *matCellDef="let row">
                <span class="table_value_name_non_capital">
                  {{ row.id }}
                </span>
              </td>
            </ng-container>
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="table_header_name"> Name</span>
              </th>
              <td mat-cell *matCellDef="let row">
                <span class="table_value_name_non_capital">
                  {{ row.name }}
                </span>
              </td>
            </ng-container>
            <ng-container matColumnDef="state">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class="table_header_name"> State</span>
              </th>
              <td mat-cell *matCellDef="let row">
                <div
                  [ngClass]="{'mat_chip_status': true, 'status_active': row.state=='active', 'status_inactive': row.state!='active'}">
                  <span class="status-label">
                    {{row.state}}
                  </span>
                </div>
                <!-- {{ row.name }} -->
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="4">No data</td>
            </tr>
          </table>
          <!-- <mat-paginator #AgnPaginatorSelected [pageSizeOptions]="[5, 10, 25, 100]">
        </mat-paginator> -->
        </div>
      </div>
    </div>
  </div>
</div>

<div class="main_footer align_right">
  <button mat-button class="action_btn_no-border me-2 mb-2" [routerLink]="[route]">
    Cancel
  </button>
  <!-- <button mat-button class="delete-action-btn me-2" (click)="back()">
    previous
  </button> -->
  <button mat-button [ngClass]="{'create-btn me-2': true}" (click)="proceed()">
    next
  </button>
</div>
